import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { Button, TransitionablePortal, Modal, Icon } from "semantic-ui-react";
import { SetCBBranches, ToggleCBBranches } from "../../../../../../actions/cbBranchesActions";
import { AppState } from "../../../../../../store/configureStore";

export const ViewSavedBranches = () => {
    const dispatch = useDispatch();
    const { cbBranches } = useSelector((state: AppState) => state.cbBranches);
    const [cbModalOpen, setCbModalOpen] = useState(false);
    const [clearModalOpen, setClearModalOpen] = useState(false);

    const handleConfirm = () => {
        dispatch(SetCBBranches([]));
        setClearModalOpen(false);
    };

    useEffect(() => {
        if (cbBranches.length === 0) setCbModalOpen(false);
    }, [cbBranches.length]);

    return (
        <>
            <CSSTransition
                id="CSSTransition-viewSavedBranches-a"
                in={cbBranches.length > 0}
                timeout={400}
                classNames="neselector-transition"
                unmountOnExit
            >
                <div id="div-viewSavedBranches-a" className="saved-elements-actions">
                    <Button id="button-viewSavedBranches-close" icon="close" size="tiny" onClick={() => setClearModalOpen(true)} />
                    <Button
                        id="button-viewSavedBranches-b"
                        content="View saved branches"
                        size="tiny"
                        onClick={() => setCbModalOpen(true)}
                    />
                </div>
            </CSSTransition>
            <TransitionablePortal
                id="transitionablePortal-viewSavedBranches-a"
                open={cbModalOpen}
                onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
                transition={{ animation: "scale", duration: 300 }}
            >
                <Modal id="modal-viewSavedBranches-a" onClose={() => setCbModalOpen(false)} open closeOnDimmerClick size="small">
                    <Modal.Header id="modalHeader-viewSavedBranches-savedBranches">Saved branches</Modal.Header>
                    <Modal.Content id="modalContent-viewSavedBranches-a">
                        {cbBranches.map(x => (
                            <section id={`section-viewSavedBranches-a-${x.text}`} key={x.id} className="view-saved">
                                <p id={`p-viewSavedBranches-a-${x.text}`} key={x.id}>{x.text}</p>
                                <Icon
                                    id={`icon-viewSavedBranches-ba-${x.text}`}
                                    name="close"
                                    size="large"
                                    link
                                    onClick={() => dispatch(ToggleCBBranches(x))}
                                />
                            </section>
                        ))}
                    </Modal.Content>
                </Modal>
            </TransitionablePortal>
            <TransitionablePortal
                id="transitionablePortal-viewSavedBranches-bc"
                open={clearModalOpen}
                onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
                transition={{ animation: "scale", duration: 300 }}
            >
                <Modal id="modal-viewSavedBranches-bc" dimmer="inverted" size="mini" open onClose={() => setClearModalOpen(false)}>
                    <Modal.Header id="modalHeader-viewSavedBranches-clearAllBranches">Are you sure you want to clear all branches?</Modal.Header>
                    <Modal.Actions id="modalActions-viewSavedBranches-bc">
                        <Button id="button-viewSavedBranches-no-bc" content="No" onClick={() => setClearModalOpen(false)} />
                        <Button id="button-viewSavedBranches-yes-bc" primary content="Yes" onClick={() => handleConfirm()} />
                    </Modal.Actions>
                </Modal>
            </TransitionablePortal>
        </>
    );
};
